<div class="fq-carousel-container" (mouseenter)="(autoPlay)?autoPlayFunction(false):null" (mouseleave)="(autoPlay)?autoPlayFunction(true):null">
	<div *ngFor="let item of widgetsList">
		<app-section-carousel-item [slideContent]="item">
		</app-section-carousel-item>
	</div>

	<app-section-carousel-dots *ngIf="dots" [dotsCount]="widgetsList.length" position="middle" [activeDot]="currentItemIndex"
	  (onClick)="goTo($event)"></app-section-carousel-dots>
</div>
